/**
 * Games Commands Registry
 *
 * /games command ile oyun listesini getirir ve portalda başlatır
 */

import { Gamepad2 } from "lucide-react";
import type { SlashCommand } from "../types/command-types";
import { getAllGames } from "@/games/common/registry";
import { useGamesPortalStore } from "@/features/games-portal";
import i18n from "@/lib/i18n";

import "@/games/register-all";

const getGameLabel = (key: string) => i18n.t(key);

export const gamesCommands: SlashCommand[] = [
  {
    id: "games-root",
    trigger: "/games",
    label: "slashCommands.games",
    description: "slashCommands.gamesDesc",
    icon: <Gamepad2 className="h-5 w-5" />,
    type: "dynamic",
    dynamicLoader: async (query) => {
      try {
        const normalizedQuery = query?.trim().toLowerCase() || "";
        const games = getAllGames();

        const filtered = normalizedQuery
          ? games.filter((game) => {
              const title = getGameLabel(game.name).toLowerCase();
              const description = getGameLabel(game.description).toLowerCase();
              return (
                title.includes(normalizedQuery) ||
                description.includes(normalizedQuery) ||
                game.id.includes(normalizedQuery)
              );
            })
          : games;

        return filtered.map((game) => ({
          id: `game-${game.id}`,
          trigger: `/games/${game.id}`,
          label: game.name,
          description: game.description,
          icon: <Gamepad2 className="h-4 w-4" />,
          type: "action" as const,
          action: async () => {
            useGamesPortalStore.getState().startGame(game.id);
          },
        }));
      } catch (error) {
        return [];
      }
    },
  },
];
